import React from "react";
import CheckoutTextButton from "./CheckoutTextButton";

interface CheckoutFieldRowProps {
  label: React.ReactNode;
  actionLabel?: React.ReactNode;
  onAction?: () => void;
  actionDisabled?: boolean;
  children: React.ReactNode;
  error?: React.ReactNode;
}

const CheckoutFieldRow: React.FC<CheckoutFieldRowProps> = ({
  label,
  actionLabel,
  onAction,
  actionDisabled = false,
  children,
  error,
}) => (
  <div className="split-discount-field">
    <div className="split-discount-field-header">
      <label>{label}</label>
      {actionLabel ? (
        <CheckoutTextButton
          disabled={actionDisabled}
          onClick={onAction}
        >
          {actionLabel}
        </CheckoutTextButton>
      ) : null}
    </div>

    {children}

    {error ? (
      <div className="text-danger mt-2">
        {error}
      </div>
    ) : null}
  </div>
);

export default CheckoutFieldRow;
